export const isSafariDesktop = (): boolean => {
    const { userAgent } = navigator
    return (
        userAgent.toLowerCase().includes('safari') &&
        !userAgent.toLowerCase().includes('chrome') &&
        !userAgent.toLowerCase().includes('iphone')
    )
}
